export const GET_PRE_REGISTRATION_CONFIGURATIONS = "GET_PRE_REGISTRATION_CONFIGURATIONS"
export const GET_PRE_REGISTRATION_CONFIGURATIONS_FAIL = "GET_PRE_REGISTRATION_CONFIGURATIONS_FAIL"
export const GET_PRE_REGISTRATION_CONFIGURATIONS_SUCCESS = "GET_PRE_REGISTRATION_CONFIGURATIONS_SUCCESS"

export const ADD_NEW_PRE_REGISTRATION_CONFIGURATION = "ADD_NEW_PRE_REGISTRATION_CONFIGURATION"
export const ADD_PRE_REGISTRATION_CONFIGURATION_SUCCESS = "ADD_PRE_REGISTRATION_CONFIGURATION_SUCCESS"
export const ADD_PRE_REGISTRATION_CONFIGURATION_FAIL = "ADD_PRE_REGISTRATION_CONFIGURATION_FAIL"

export const UPDATE_PRE_REGISTRATION_CONFIGURATION = "UPDATE_PRE_REGISTRATION_CONFIGURATION"
export const UPDATE_PRE_REGISTRATION_CONFIGURATION_SUCCESS = "UPDATE_PRE_REGISTRATION_CONFIGURATION_SUCCESS"
export const UPDATE_PRE_REGISTRATION_CONFIGURATION_FAIL = "UPDATE_PRE_REGISTRATION_CONFIGURATION_FAIL"

export const DELETE_PRE_REGISTRATION_CONFIGURATION = "DELETE_PRE_REGISTRATION_CONFIGURATION"
export const DELETE_PRE_REGISTRATION_CONFIGURATION_SUCCESS = "DELETE_PRE_REGISTRATION_CONFIGURATION_SUCCESS"
export const DELETE_PRE_REGISTRATION_CONFIGURATION_FAIL = "DELETE_PRE_REGISTRATION_CONFIGURATION_FAIL"





